'use client';

import { FaWhatsapp } from 'react-icons/fa';
import { useState, useEffect } from 'react';

import { useLanguage } from '@/contexts/LanguageContext';

interface WhatsAppButtonProps {
  phoneNumber?: string;
}

export default function WhatsAppButton({ 
  phoneNumber = '905438999586'
}: WhatsAppButtonProps) {
  const { t, locale } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Sayfa yüklendikten 2 saniye sonra butonu göster
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const getWhatsAppMessage = () => {
    switch (locale) {
      case 'en':
        return 'Hello, I would like to make an appointment.';
      case 'de':
        return 'Hallo, ich möchte einen Termin vereinbaren.';
      default:
        return 'Merhaba, randevu almak istiyorum.';
    }
  };

  const getTooltipText = () => {
    switch (locale) {
      case 'en':
        return 'Contact us via WhatsApp';
      case 'de':
        return 'Kontaktieren Sie uns über WhatsApp';
      default:
        return 'WhatsApp ile iletişime geç';
    }
  };

  const handleClick = () => {
    const message = getWhatsAppMessage();
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50">
      <button
        onClick={handleClick}
        className="group relative bg-green-500 hover:bg-green-600 text-white rounded-full p-3 sm:p-4 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 focus:outline-none focus:ring-4 focus:ring-green-300"
        aria-label={getTooltipText()}
      >
        <FaWhatsapp className="w-5 h-5 sm:w-6 sm:h-6" />
        
        {/* Pulse animation */}
        <div className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-20"></div>
        
        {/* Tooltip - sadece desktop'ta göster */}
        <div className="hidden sm:block absolute right-full mr-3 top-1/2 transform -translate-y-1/2 bg-gray-800 text-white text-sm px-3 py-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap">
          {getTooltipText()}
          <div className="absolute left-full top-1/2 transform -translate-y-1/2 border-4 border-transparent border-l-gray-800"></div>
        </div>
      </button>
    </div>
  );
}
